import { useQuery } from "@tanstack/react-query";
import { ConfigItemType } from "../actions/Tenants/config/constantsTyped";
import { callAvosApi } from "../utils/useAvosApiHook";

export const useTenantActiveConfigs = (tenantId: string | undefined) => useQuery({
    queryKey: ["tenantActiveConfigs", tenantId],
    queryFn: async (): Promise<ConfigItemType[]> => {
        const { data } = await callAvosApi(`/tenants/${tenantId}/configs/active`);
        return data;
    },
    enabled: !!tenantId,
});
